<ion-item lines="none">
  <ion-text color="secondary">
    <h1>{{'NAV.ENTERPRISE'|translate}}</h1>
  </ion-text>
  <ion-buttons slot="end">
    <ion-button fill="clear" size="small" *ngIf="noEmployers" (click)="onClickRequestTestAccount()">
      <ion-icon name="game-controller-outline" size="small"></ion-icon>
    </ion-button>
    <ion-button fill="clear" size="small" class="ion-hide">
      <ion-icon name="time-outline" size="small"></ion-icon>
    </ion-button>
  </ion-buttons>
</ion-item>
<ion-item lines="none" button detail="false" (click)="onClickSelect()">
  <ion-label *ngIf="!selected">
    <h2>{{'ENTERPRISE'|translate}}</h2>
  </ion-label>
  <ion-label *ngIf="selected">
    <h2>{{selected.name}}</h2>
  </ion-label>
  <ion-icon name="chevron-down-outline" size="small"></ion-icon>
</ion-item>

